import styled from 'styled-components';

export const DefaultHeader = styled.header((props) => ({
  backgroundColor: props.theme.newPalette.background.white,
  color: props.theme.newPalette.typography[100],
  width: '300px',
  flexShrink: 0,
  padding: '20px 0px',
  borderRightWidth: 1,
  borderStyle: 'solid',
  borderColor: props.theme.newPalette.background.gray[300],
  [`@media${props.theme.devices.laptop}`]: {
    padding: '16px 0',
    width: 'auto',

    hr: {
      display: 'none',
    },
  },
}));

export const Text = styled.p((props) => ({
  opacity: 0.8,
  fontFamily: '"Roboto", sans-serif',
  fontSize: '16px',
  lineHeight: '1.4',
  margin: '0 0 17px',
  color: props.theme.newPalette.typography[200],

  [`@media${props.theme.devices.laptop}`]: {
    display: 'none',
  },
}));

export const HeaderContent = styled.div((props) => ({
  [`@media${props.theme.devices.laptop}`]: {
    padding: '0 16px',
  },
}));

export const Divider = styled.hr((props) => ({
  width: '100%',
  borderTopWidth: props.width || '2px',
  margin: props.margin || '0 0 23px',
  borderColor: "#ff00ff",

  [`@media${props.theme.devices.laptop}`]: {
    display: 'none',
  },
}));
